import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/core';
import '@angular/common';
import '@angular/http';
import '@angular/router';
import '@angular/forms';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import './styles/bootstrap';
import './styles/gentelella';
import './styles/fawesome';
import './styles/icheck';
import 'lodash';
import 'jquery';
import './styles/datepicker';
import 'bootstrap-tokenfield/dist/css/bootstrap-tokenfield.css';
import './styles/material.menu';
// import './styles/bootstrap/js/dropdown.js'


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/vendor.ts